/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Exception_RuleInputs */



/**
* | output |
* | --- |
* | "What do you switch off" |
*
* @param {Meetings_Exception_RuleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_exception_rule = /** @type {((inputs?: Meetings_Exception_RuleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Exception_RuleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wat schakel je uit")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce que vous désactivez")
	return /** @type {LocalizedString} */ ("What do you switch off")
});